import { ADD_DETAILS_INFO} from "../actions";

export const addDetailsInfo = (item, dispatch) => {
  dispatch(addDetails(item));
};

export const addDetails = (item) => {
  return { type: ADD_DETAILS_INFO, payload: item };
};